// A blocking "are you sure?" dialog for a destructive action (cancelling a lesson).
// Built after cancelling the wrong lesson by mistake — two adjacent "Cancel" buttons
// (a form's own cancel toggle, and a real booked lesson's cancel) with no confirmation
// step made that single misclick directly destructive. This is the fix: nothing
// destructive fires until a second, explicit confirmation.
export function ConfirmDialog({
  open, title, message, confirmLabel = 'Yes, cancel it', cancelLabel = "No, don't cancel", onConfirm, onCancel,
}: {
  open: boolean
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  onConfirm: () => void
  onCancel: () => void
}) {
  if (!open) return null
  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(27,42,74,0.5)', zIndex: 300,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
      }}
      onClick={onCancel}
    >
      <div
        style={{ background: '#fff', borderRadius: 14, padding: '24px', maxWidth: 380, width: '100%' }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ font: '600 17px Lora, serif', color: '#1B2A4A', marginBottom: 8 }}>{title}</div>
        <div style={{ font: '400 13.5px/1.5 Inter, sans-serif', color: 'rgba(27,42,74,0.6)', marginBottom: 22 }}>{message}</div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '9px 16px', background: 'rgba(27,42,74,0.06)', border: 'none', borderRadius: 8,
              color: '#1B2A4A', font: '600 13px Inter, sans-serif', cursor: 'pointer',
            }}
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '9px 16px', background: 'var(--danger)', border: 'none', borderRadius: 8,
              color: '#fff', font: '600 13px Inter, sans-serif', cursor: 'pointer',
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
